const SHOP_DATA = {
    haldi: {
      id: 1,
      title: 'Haldi',
      routeName: 'haldi',
      items: [
        {
          id: 1,
          name: 'Haldi Powder',
          imageUrl: 'https://i.ibb.co/RhCpRKW/haldi.jpg',
          price: 25
        },
        {
          id: 2,
          name: 'Haldi',
          imageUrl: 'https://i.ibb.co/RhCpRKW/haldi.jpg',
          price: 18
        },
        {
          id: 3,
          name: 'Haldi Powder',
          imageUrl: 'https://i.ibb.co/RhCpRKW/haldi.jpg',
          price: 25
        },
        {
          id: 4,
          name: 'Haldi',
          imageUrl: 'https://i.ibb.co/RhCpRKW/haldi.jpg',
          price: 18
        }
      ]
    },
mirch:{
      id: 2,
      title: 'Mirch',
      routeName: 'mirch',
      items: [
        {
          id: 5,
          name: 'mirch powder',
          imageUrl: '   https://i.ibb.co/CMmvTMc/lal.jpg',
          price: 220
        },
        {
          id: 6,
          name: 'Mirch',
          imageUrl: 'https://i.ibb.co/CMmvTMc/lal.jpg',
          price: 280
        },
        {
          id: 7,
          name: 'mirch powder',
          imageUrl: '   https://i.ibb.co/CMmvTMc/lal.jpg',
          price: 220
        },
        {
          id: 8,
          name: 'Mirch',
          imageUrl: 'https://i.ibb.co/CMmvTMc/lal.jpg',
          price: 280
        }
      ]
    },
dhaniya:{
      id: 3,
      title: 'Dhaniya',
      routeName: 'dhaniya',
      items: [
        {
          id: 9,
          name: 'Dhaniya powder',
          imageUrl: 'https://i.ibb.co/BL18HkZ/dhaniya.jpg',
          price: 125
        },
        {
          id: 10,
          name: 'Dhaniya',
          imageUrl: 'https://i.ibb.co/BL18HkZ/dhaniya.jpg',
          price: 90
        },
        {
          id: 11,
          name: 'Dhaniya powder',
          imageUrl: 'https://i.ibb.co/BL18HkZ/dhaniya.jpg',
          price: 125
        },
        {
          id: 12,
          name: 'Dhaniya',
          imageUrl: 'https://i.ibb.co/BL18HkZ/dhaniya.jpg',
          price: 90
        }
      ]
    },
besan:{
      id: 4,
      title: 'Besan',
      routeName: 'besan',
      items: [
        {
          id: 13,
          name: 'Besan',
          imageUrl: 'https://i.ibb.co/2yqCXbr/besan.jpg',
          price: 25
        },
        {
          id: 14,
          name: 'Besan',
          imageUrl: 'https://i.ibb.co/2yqCXbr/besan.jpg',
          price: 25
        },
      ]
    }
};
  
  export default SHOP_DATA;